import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/byihuse-logo-white.png'


const _withScopeId = n => (_pushScopeId("data-v-94e0b028"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex align-items-center justify-content-center"
}
const _hoisted_2 = { class: "mx-4 d-flex flex-column justify-content-center" }
const _hoisted_3 = {
  key: 1,
  class: "small-fs"
}
const _hoisted_4 = {
  key: 2,
  class: "small-fs"
}
const _hoisted_5 = {
  key: 1,
  class: "py-3 bg-success"
}
const _hoisted_6 = { class: "container d-flex flex-column flex-md-row align-items-md-center justify-content-md-between" }
const _hoisted_7 = { class: "logo-menu d-flex align-items-center justify-content-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "logo me-mb-3",
  src: _imports_0
}, null, -1))
const _hoisted_9 = { class: "main-menu" }
const _hoisted_10 = { class: "d-flex justify-content-center" }
const _hoisted_11 = { class: "main-account mt-3 mt-md-0" }
const _hoisted_12 = { class: "user-account text-center" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "dropdown" }
const _hoisted_15 = {
  href: "javascript:;",
  class: "dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_16 = { class: "dropdown-menu dropdown-menu-center" }
const _hoisted_17 = {
  key: 2,
  style: {"background-color":"#fafbfe"}
}
const _hoisted_18 = { class: "container py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillPreparing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.hasNetworkError)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: ['fas', 'spinner'],
                  style: {"font-size":"4rem"},
                  class: "mb-2"
                }))
              : _createCommentVNode("", true),
            (!_ctx.hasNetworkError)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_ctx.language.loadingUserData), 1))
              : _createCommentVNode("", true),
            (_ctx.hasNetworkError)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(_ctx.language.networkErrorMsg), 1))
              : _createCommentVNode("", true),
            _createElementVNode("a", {
              class: "btn btn-primary mt-2",
              href: "javascript:;",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cleanAndGoLogin && _ctx.cleanAndGoLogin(...args)))
            }, _toDisplayString(_ctx.language.login), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isStillPreparing)
      ? (_openBlock(), _createElementBlock("header", _hoisted_5, [
          _createElementVNode("nav", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/app/dashboard" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.language.dashboard), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/app/customers" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.language.customers), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/app/suppliers" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.language.suppliers), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/app/products" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.language.products), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/app/sales" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.language.sales), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/app/analytics" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.language.analyticals), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/app/settings" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.language.settings), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    src: _ctx.imageFilePath,
                    alt: "",
                    class: "user-img object-fit-cover rounded-circle border me-2 d-inline-block"
                  }, null, 8, _hoisted_13),
                  _createElementVNode("span", _hoisted_14, [
                    _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.currentUserName), 1),
                    _createElementVNode("ul", _hoisted_16, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_RouterLink, {
                          class: "dropdown-item",
                          to: "/app/myprofile"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.language.myProfile), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:;",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onQuitApp && _ctx.onQuitApp(...args)))
                        }, _toDisplayString(_ctx.language.signOut), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isStillPreparing)
      ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_router_view)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AppFooter)
  ], 64))
}